import { sizeOptionsOrDefault } from './utils';
import { Rectangle } from './Rectangle';
/**
 * Represents an On-Page Connector shape, a flowchart element used to indicate continuation
 * of a flowchart on the same page. Extends the Rectangle class with a custom circular path.
 */
export class OnPageConnector extends Rectangle {
    /**
     * @hidden
     * Draws the on-page connector shape path as a circle with arcs.
     */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const centerX = width / 2;
        const radius = (Math.min(width, height) / 2);
        drawingElement
            .moveTo([centerX, 0])
            .arcTo([centerX, height], radius, radius, false, true)
            .arcTo([centerX, 0], radius, radius, false, true);
    }
}
